// 各組織コードに対してExcel/CSV出力対象とするsendParameterNameを定義
export const TARGET_SEND_PARAMS: { [orgCode: string]: string[] } = {
  '007': ['200', '202', '107'],
  '009': [
    'totalVisitor',
    'totalSales',
    'tax',
    'salesDeduction',
    'netSales',
    'cash',
    'credit',
    'gift',
    'eMoney',
    'creditSales',
    'cashBalance',
  ],
  '988': ['200', '202', '107'],
  '999': ['netSales', 'totalVisitor'],
}
